import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import Draggable from "react-draggable";
import OT from "@opentok/client";
import createOpentokHardwareSetupComponent from "./VonageHardwareSetup";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";
import CallEndIcon from "@material-ui/icons/CallEnd";
import { Row, Col } from "reactstrap";
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore';
import UnfoldLessIcon from '@material-ui/icons/UnfoldLess';
import CloseIcon from "@material-ui/icons/Close";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import PermCameraMicIcon from "@material-ui/icons/PermCameraMic";
import MicOffIcon from '@material-ui/icons/MicOff';
export default function VonageSpeakerDialog(props) {
  const [hardwareSetup, setHardwareSetup] = useState(null);
  const [showHwSetup, setShowHwSetup] = useState(true);
  const [publisher, setPublisher] = useState(null);
  const [session, setSession] = useState(props.session);
  const [collapsed, setCollapsed] = useState(false);
  const onDismountRef = useRef();
  const { hubConnection, eventId, channel, clientKey, clientName, companyName, videoWall = false, videoWallProps } = props;

  useEffect(() => {
    if (hubConnection && hubConnection.state == 1) {
      if ((!session || !session.capabilities || session.capabilities.publish !== 1) && !videoWall) {
        hubConnection.invoke("getSessionAndToken", eventId, channel, clientKey, "PUBLISHER", true);
      } else if (videoWall == true) {
        const { apiKey, sessionId, token } = videoWallProps;
        onGetDialogSessionAndToken(apiKey, sessionId, token);
      } else {
        setTimeout(() => {
          var hardwareSetup = createOpentokHardwareSetupComponent("vonage-setup-dialog-done", { insertMode: "before" }, (error) => {
            if (error) console.error(error);
          });
          setHardwareSetup(hardwareSetup);
        }, 100);
      }

    }
    return () => onDismountRef.current()
  }, []);
  const onDismount = () => {
    if (session) {
      const { streams, token } = props;
      if (streams && streams.length > 0) {
        while (streams.length > 0) {
          session.unsubscribe(streams[0]);
        }
      }
      if (publisher) session.unpublish(publisher);
      hubConnection.off("onGetDialogSessionAndToken", onGetDialogSessionAndToken);
      if (hardwareSetup) {
        hardwareSetup.destroy();
      }
      session.disconnect();
      if (token) {
        session.connect(props.token, function (error) {
          // If the connection is successful, publish to the session
          if (error) console.error(error);
        });
      }
    }
    else {
      hubConnection.off("onGetDialogSessionAndToken", onGetDialogSessionAndToken);
    }
  };
  useEffect(() => {
    onDismountRef.current = onDismount;
    if (hubConnection) {
      hubConnection.on("onDeactivateSpeaker", onRemoteHangUp);
      hubConnection.on("onGetDialogSessionAndToken", onGetDialogSessionAndToken);
      hubConnection.on("onKickPersonFromWall", onKickPersonFromWall);
    }
    return () => {
      if (hubConnection) {
        hubConnection.off("onDeactivateSpeaker", onRemoteHangUp);
        hubConnection.off("onGetDialogSessionAndToken", onGetDialogSessionAndToken);
        hubConnection.off("onKickPersonFromWall", onKickPersonFromWall);
      }
    };
  });
  function onKickPersonFromWall(name, key) {
    if (videoWall && videoWallProps.wallName?.toLowerCase() === name.toLowerCase() && clientKey === key && session && publisher) {
      session.unpublish(publisher);
      if (hardwareSetup) {
        hardwareSetup.destroy();
      }
      if (session) session.disconnect();
      props.handleClose();
    }
  }
  function onGetDialogSessionAndToken(apiKey, sessionId, token) {
    if (session) {
      const { streams } = props;
      while (streams.length > 0) {
        session.unsubscribe(streams[0]);
      }
      session.disconnect();
      session.connect(token, function (error) {
        // If the connection is successful, publish to the session
        if (error) {
          if (error) console.error(error);
        } else {
          var hardwareSetup = createOpentokHardwareSetupComponent("vonage-setup-dialog-done", { insertMode: "before", videoWall }, (error) => {
            if (error) console.error(error);
          });
          setHardwareSetup(hardwareSetup);
        }
      });
    } else {
      var newSession = OT.initSession(apiKey, sessionId);
      newSession.connect(token, function (error) {
        // If the connection is successful, publish to the session
        if (error) {
          if (error) console.error(error);
        } else {
          setSession(newSession);
          var hardwareSetup = createOpentokHardwareSetupComponent("vonage-setup-dialog-done", { insertMode: "before", videoWall }, (error) => {
            if (error) console.error(error);
          });
          setHardwareSetup(hardwareSetup);
        }
      });
    }
  }
  function startPublisher(param) {
    var targetContainer = "vonage-publisher-dialog";
    var options = {
      insertMode: "append",
      width: "100%",
      height: "100%",
      resolution: '1280x720',
      audioSource: hardwareSetup.audioSource(),
      videoSource: hardwareSetup.videoSource(),
      publishAudio: !videoWall && (param !== "videoOnly" || !hardwareSetup.videoSource()) ? true : false,
      publishVideo: param !== "audioOnly" || !hardwareSetup.audioSource() ? true : false,
      showControls: false,
      name: clientKey,
    };
    if (typeof param === "object") options = { ...options, ...param };
    var publisher = OT.initPublisher(targetContainer, options, (e) => {
      if (e) console.error(e);
    });
    publisher.on("destroyed", onPublisherDestroyed);
    session.publish(publisher, (e) => {
      if (e) console.error(e);
      else {
        props.setStreamIdToMute(publisher.stream.id);
      }
      if (hubConnection && hubConnection.state == 1) {
        hubConnection.invoke("LogPublisherStatus", session.id, eventId, channel, clientKey, false, "Start");
      }
    });
    setPublisher(publisher);
  }
  function onPublisherDestroyed() {
    if (hubConnection && hubConnection.state == 1) {
      hubConnection.invoke("LogPublisherStatus", session.id, eventId, channel, clientKey, false, "Stop");
    }
  }
  function updatePublisherDevices() {
    const audioSource = hardwareSetup.audioSource();
    const videoSource = hardwareSetup.videoSource();
    publisher.setAudioSource(audioSource.deviceId);
    publisher.setVideoSource(videoSource.deviceId);
  }

  function onRemoteHangUp(badgeNo) {
    if (badgeNo == clientKey) {
      session.unpublish(publisher);
      if (hardwareSetup) {
        hardwareSetup.destroy();
      }
      if (session) session.disconnect();
      props.handleClose();
    }
  }

  function hangUp() {
    if (publisher && session) {
      session.unpublish(publisher);
    }
    if (session) session.disconnect();
    hardwareSetup.destroy();
    if (hubConnection && hubConnection.state == 1) {
      hubConnection.invoke("deactivateSpeaker", eventId, clientKey);
    }
    props.handleClose();
  }
  const body = document.getElementById("view-wrapper");
  return ReactDOM.createPortal(
    <Draggable axis="both" handle="#draggable-dialog-title" defaultPosition={{ x: window.innerWidth / 2 - 200, y: window.innerHeight / 2 - 250 }} position={null} grid={[5, 5]} bounds="parent">
      <Paper className={`call-dialog ${collapsed ? "collapsed" : ""}`} style={{ width: "370px", zIndex: 999, position: "absolute" }}>
        <DialogTitle style={{ border: "1px solid #333", cursor: "move", backgroundColor: "#333", color: "white" }} id="draggable-dialog-title">
          <Row>
            <Col className="text-left" style={{ display: "flex", alignItems: "center" }}>
              {!publisher ? (
                <SystemLabel name="ShareCamera" />
              ) : (
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                  <div className="on-air-icon" />
                  <SystemLabel name="Live" />
                  {videoWall ? <MicOffIcon style={{ marginLeft: "5px" }} /> : null}
                </div>
              )}
            </Col>
            <Col className="text-right">
              {publisher ? (
                <IconButton className="primary-text" onClick={() => setCollapsed(!collapsed)}>
                  {!collapsed ? <UnfoldLessIcon /> : <UnfoldMoreIcon />}
                </IconButton>
              ) : null}
            </Col>
          </Row>
        </DialogTitle>
        <div style={{ display: collapsed ? "flex" : "block", height: "100%" }}>
          <DialogContent style={{ border: "1px solid #333", padding: 0, backgroundColor: "#333", overflow: "hidden" }}>
            <div
              id="vonage-publisher-dialog"
              className="handle"
              style={{
                height: "180px",
                width: "320px",
                margin: "auto",
                display: publisher && !showHwSetup ? "block" : "none",
              }}
            ></div>
            <div
              id="vonage-hwsetup-dialog"
              style={{
                display: showHwSetup ? "flex" : "none",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
                backgroundColor: "#333",
              }}
            >
              <button
                id="vonage-setup-dialog-done"
                className="vonage-setup-done"
                onClick={() => {
                  setShowHwSetup(false);
                  publisher ? updatePublisherDevices() : startPublisher();
                }}
              >
                <EventLabel2 name="ConfirmCameraSettings" groupName="DigitalMeeting.Vonage" />
              </button>
            </div>
          </DialogContent>
          <DialogActions style={{ backgroundColor: "#333", padding: 15, border: "1px solid #333" }}>
            {publisher && !showHwSetup && !collapsed ? (
              <Button
                startIcon={<PermCameraMicIcon />}
                style={{ backgroundColor: "#888", fontSize: 12, margin: "auto", borderRadius: 15, color: "#fff", padding: "6px 15px" }}
                onClick={() => setShowHwSetup(true)}
              >
                <SystemLabel name="ChangeCameraSettings" />
              </Button>
            ) : null}
            {publisher ? (
              <Button startIcon={<CallEndIcon />} onClick={hangUp} style={{ backgroundColor: "#ec3131", fontSize: 12, margin: "auto", borderRadius: 15, color: "#fff", padding: "6px 15px" }}>
                <SystemLabel name="HungUp" />
              </Button>
            ) : (
              <Button startIcon={<CloseIcon />} onClick={hangUp} style={{ backgroundColor: "rgb(74 73 73)", fontSize: 12, margin: "auto", borderRadius: 15, color: "#fff", padding: "6px 15px" }}>
                <SystemLabel name="Cancel" />
              </Button>
            )}
          </DialogActions>
        </div>
      </Paper>
    </Draggable>,
    body
  );
}
